import { useEffect, useState } from 'react';

// False for the server render and the hydrating render, which must match it.
export default function useMounted() {
	const [mounted, setMounted] = useState(false);
	useEffect(() => setMounted(true), []);
	return mounted;
}
